import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTY_INVOICING = {
  'list': [],
  'loading': false,
};

export const warrantyInvoicing = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_INVOICING, {
    [ActionTypes.PROCESSING_WARRANTY_INVOICING_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESSED_WARRANTY_INVOICING_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.PROCESSED_WARRANTY_INVOICING_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.UPDATING_TWC_WARRANTY_INVOICING]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TWC_WARRANTY_INVOICING]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.UPDATED_TWC_WARRANTY_INVOICING_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTY_INVOICING_LIST]: (state, action) => ({
      ...INITIAL_STATE_WARRANTY_INVOICING,
    }),
  })(state, action);
};
